

window.getPonfInfo = function(id, destiny_element) {
    $.ajax({
        url: "/api/ponds/"+id+"/pond_info",
        type: 'GET'
    }).done(function(e) {
    	if (e.response_status == "error-acceso-denegado"){
    		console.log(e);
    		return;
    	}
    	if (destiny_element == "#pond_fish_number"){
    		$(destiny_element).val(e.fish_quantity);
            pond_min = Math.max(2, parseInt(e.fish_quantity*0.001));
    		$("#min_fish_number").val(pond_min);
    		$('#minFishSpan').html(pond_min);
            recalculateFishCount();
    	}
    });  
}


window.getBiofilterfInfo = function(id) {
    $.ajax({
        url: "/api/biofilters/"+id+"/biofilter_info",
        type: 'GET'
    }).done(function(e) {
        if (e.response_status == "error-acceso-denegado"){
            console.log(e);
            return;
        }
    });  
}
